module.exports = __webpack_public_path__ + "media/styles/images/png/table-handle-373bb7b6cba99834c1b64ee4944509f5.png";